import { Play } from "lucide-react";
import Picture from "@/components/Picture";

export default function GalleryGrid({ items, onOpen }) {
  if (!items || items.length === 0) {
    return (
      <div
        data-testid="gallery-empty"
        className="text-[#737373] text-sm tracking-wide py-24 text-center"
      >
        No items match this filter.
      </div>
    );
  }

  return (
    <div className="hl-masonry" data-testid="gallery-grid">
      {items.map((item, idx) => (
        <button
          key={item.id}
          onClick={() => onOpen(item.id)}
          data-testid={`gallery-tile-${item.id}`}
          className={`hl-tile hl-size-${item.size || "standard"} block w-full text-left`}
          aria-label={`Open ${item.title}`}
        >
          <Picture
            item={item}
            variant="thumbnail"
            className="w-full h-full object-cover"
            loading={idx < 6 ? "eager" : "lazy"}
            decoding="async"
          />
          {item.type === "video" && (
            <>
              <span className="hl-video-label">Video</span>
              <span className="hl-play" aria-hidden="true">
                <Play size={22} fill="currentColor" />
              </span>
            </>
          )}
          <span className="hl-overlay" />
          <div className="hl-meta">
            <span className="hl-category">{item.category}</span>
            <h3 className="hl-title">{item.title}</h3>
            <div className="hl-client">Client: {item.client}</div>
          </div>
        </button>
      ))}
    </div>
  );
}
